(function () {
	/**
   * Renders Municipal Weather DETAIL Page (new structure; slug-based)
   * @param {Object} props - Routing & page context
   * @returns {Promise<object>}
   */
	WebBaseAprovLV.renderMunicipalWeatherPage = function (props) {
		var params = {
			page: (props.context.params.page || ''),
			detail: (props.context.params.detail || '')
		};
		var tlParam = (props && props.context && props.context.query && props.context.query.tl)
			? String(props.context.query.tl)
			: null;
		var model = {
			element: null,
			template: 'templates/municipal-weather.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {},
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				venueMunicipalSelectedAreaData: null,
				venueMunicipalAreasData: null,
				skyConditions: null,
				muniDetail: null,
				municipalByDayForVenue: null,
				latestUpdateISO: null,
				currentTL: null
			}
		};
		var langparam = (WebBaseAprovLV.lang === 'lld' ? 'de' : WebBaseAprovLV.lang);
		var L = langparam;
		var fetchAsync = WebBaseAprovLV.Utils.fetchAsync({ dataType: 'json', cache: true });
		var fetchFresh = WebBaseAprovLV.Utils.fetchAsync({ dataType: 'json', cache: false });
		var timeLayoutIds = ['144000000', '144001440', '144002880', '144004320', '144005760', '144007200'];
		var cb = Date.now();
		var base = (WebBaseAprovLV.config.azureStorageUrl[WebBaseAprovLV.lang] || '');
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
			.then(function (pageXhr) {
				var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
				model.data.pageRaw = pageRaw;
				model.data.navRaw = {};
				var staticCalls = [
					fetchAsync(base + 'forecast-data/website/static-data/municipalities.json'),
					fetchAsync(base + 'forecast-data/website/static-data/sky_conditions.json')
				];
				var bulletinCalls = timeLayoutIds.map(function (id) {
					var url = base + 'forecast-data/website/southtyrol/' + L + '_' + id + '.json'
						+ (base.indexOf('?') === -1 ? ('?cb=' + cb) : ('&cb=' + cb));
					var dfd = $.Deferred();
					fetchFresh(url)
						.done(function (resp) { dfd.resolve(Array.isArray(resp) ? resp[0] : resp); })
						.fail(function (_jq, textStatus) {
							console.warn('[detail] municipal forecast not found:', url, textStatus);
							dfd.resolve(null);
						});
					return dfd.promise();
				});
				return $.when.apply($, staticCalls.concat(bulletinCalls));
			})
			.then(function () {
				var args = Array.prototype.slice.call(arguments);
				var muniX = args[0];
				var skyX = args[1];
				var pubs = args.slice(2);
				var municipalitiesRaw = (Array.isArray(muniX) ? muniX[0] : (muniX || [])) || [];
				var skyRaw = (Array.isArray(skyX) ? skyX[0] : (skyX || [])) || [];
				var municipalities = WebBaseAprovLV.Utils.localizeMunicipalRecords(municipalitiesRaw, WebBaseAprovLV.lang) || [];
				(function () {
					var lang = WebBaseAprovLV.lang || 'de';
					var eff = (lang === 'lld' ? 'lld' : lang);
					var key = 'name_' + eff;
					municipalities.sort(function (a, b) {
						var an = (a && (a[key] || a.name || '')).toString();
						var bn = (b && (b[key] || b.name || '')).toString();
						return an.localeCompare(bn, eff, { sensitivity: 'base' });
					});
				})();
				function slugMatches(rec, slug) {
					if (!rec || !slug) { return false; }
					var sL = String(slug).toLowerCase();
					var fields = [
						rec['url_slug_' + L],
						rec['url_slug_de'], rec['url_slug_it'], rec['url_slug_en'], rec['url_slug_lld']
					].filter(Boolean);
					return fields.some(function (f) { return String(f).toLowerCase() === sL; });
				}
				var selected =
					municipalities.find(function (r) { return slugMatches(r, params.detail); }) ||
					municipalities.find(function (r) { return String(r.id) === String(params.detail); }) ||
					null;
				if (params.detail && !selected) {
					console.error('[detail] municipality not found for slug/id:', params.detail);
					return $.Deferred().reject({ code: 404, where: 'municipal-detail', detail: params.detail }).promise();
				}
				var selectedId = selected ? String(selected.id) : '';
				var municipalByDayForVenue = {};
				var latestUpdateISO = null;
				var currentTL = null;
				function parseNum(v) {
					if (v == null) { return null; }
					if (typeof v === 'number') { return (isFinite(v) ? v : null); }
					if (typeof v === 'string') {
						var n = Number(v.replace(',', '.').trim());
						return (isFinite(n) ? n : null);
					}
					return null;
				}
				(pubs || [])
					.map(function (r) { return Array.isArray(r) ? r[0] : r; })
					.filter(function (r) { return r && r.data && Array.isArray(r.data.bulletins); })
					.forEach(function (pub) {
						var lu = pub && pub.meta && (pub.meta.last_update || pub.meta.date);
						if (lu && (!latestUpdateISO || new Date(lu) > new Date(latestUpdateISO))) {
							latestUpdateISO = lu;
						}
						(pub.data.bulletins || []).forEach(function (b) {
							var iso = (b && b.period && b.period.start
								? WebBaseAprovLV.Utils.localIsoDayFromUTC(b.period.start)
								: '');
							if (!iso) { return; }
							if (!municipalByDayForVenue[iso]) {
								municipalByDayForVenue[iso] = {
									summary: null,
									metric: null,
									meta: { last_update: lu || null }
								};
							}
							if (!municipalByDayForVenue[iso].summary) {
								var T = b.temperatures || b.temperature || {};
								var Tmin = T && T.min ? T.min : null;
								var Tmax = T && T.max ? T.max : null;
								municipalByDayForVenue[iso].summary = {
									id_time_layout: b.id_time_layout,
									title: b.title || '',
									conditions: b.conditions || '',
									weather: b.weather || '',
									temperatureText: b.temperature || '',
									reliability: b.reliability,
									skyKey: String(b.skyCondition || '').toUpperCase(),
									tminLow: parseNum(Tmin && Tmin.low),
									tminHigh: parseNum(Tmin && Tmin.high),
									tmaxLow: parseNum(Tmax && Tmax.low),
									tmaxHigh: parseNum(Tmax && Tmax.high),
									astronomy: b.astronomy || null
								};
								if (!tlParam && !currentTL && b.id_time_layout != null) {
									currentTL = String(b.id_time_layout);
								}
							}
							if (selectedId) {
								var m = (Array.isArray(b.municipalityMetrics) ? b.municipalityMetrics : []).find(function (x) {
									return String(x.venueId) === selectedId;
								});
								if (m) {
									municipalByDayForVenue[iso].metric = {
										venueId: String(m.venueId),
										sky_condition: m.sky_condition || null,
										temperature_minimum: m.temperature_minimum,
										temperature_maximum: m.temperature_maximum,
										rain_fall: m.rain_fall,
										rain_probability: m.rain_probability,
										sunshine_duration: (m.sunshine_hours != null ? m.sunshine_hours : (m.sunshine_duration != null ? m.sunshine_duration : null)),
										wind_speed: m.wind_speed,
										wind_gust: m.wind_gust,
										wind_direction: m.wind_direction,
										snow_level: m.snow_level,
										fresh_snow: m.fresh_snow,
										freezing_level: m.freezing_level
									};
								}
							}
						});
					});
				var muniDetailUrl = (selectedId
					? (base + 'forecast-data/website/municipalities/' + selectedId + '.json')
					: null);
				var muniDetailPromise = muniDetailUrl
					? fetchFresh(muniDetailUrl + (muniDetailUrl.indexOf('?') === -1 ? ('?cb=' + cb) : ('&cb=' + cb)))
					: $.Deferred().resolve(null).promise();
				model.data.venueMunicipalAreasData = municipalities;
				model.data.venueMunicipalSelectedAreaData = selected;
				model.data.skyConditions = skyRaw || [];
				model.data.municipalByDayForVenue = municipalByDayForVenue;
				model.data.latestUpdateISO = latestUpdateISO;
				model.data.currentTL = tlParam || currentTL || null;
				return muniDetailPromise;
			})
			.then(function (muniDetailX) {
				var muniDetail = Array.isArray(muniDetailX) ? muniDetailX[0] : muniDetailX;
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: (WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {}),
					nav: (WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {}),
					muniDetail: muniDetail || null
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			})
			.then(function (ejsmodel) {
				var sel = ejsmodel.data.venueMunicipalSelectedAreaData || {};
				function slugOrId(rec, lang) {
					var eff = (lang === 'lld' ? 'lld' : lang);
					return (rec && rec['url_slug_' + eff]) ? rec['url_slug_' + eff] : (rec && rec.id ? String(rec.id) : '');
				}
				ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
					page: {
						segment: {
							'de': 'gemeindewetter' + '/' + slugOrId(sel, 'de'),
							'it': 'meteo-comuni' + '/' + slugOrId(sel, 'it'),
							'lld': 'temp-chemuns' + '/' + slugOrId(sel, 'lld'),
							'en': 'municipality-weather' + '/' + slugOrId(sel, 'en')
						}
					},
					detail: { id: '' }
				}, $('a.langchange'));
				return ejsmodel;
			})
			.fail(function (err) {
				if (err && err.code === 404) {
					return WebBaseAprovLV.render404();
				}
				console.error('[municipal] render failed:', err);
				return WebBaseAprovLV.render404();
			})
			.promise();
	};
})();
